module.exports = __webpack_public_path__ + "img/闭环.3f86d360.png";